/* Malichus Gallery — dialogs, hero sequence, rails, header state. */
(function () {
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-dialog-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-dialog-open'));
      if (d && d.showModal) { d.showModal(); var f = d.querySelector('input[type=search]'); if (f) f.focus(); }
      return;
    }
    var close = e.target.closest('[data-dialog-close]');
    if (close) { var dd = close.closest('dialog'); if (dd) dd.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
    var cur = e.target.closest('.curtain');
    if (cur) cur.classList.add('is-skip');
    var rb = e.target.closest('[data-rail-btn]');
    if (rb) {
      var rail = document.getElementById(rb.getAttribute('data-rail'));
      if (rail) {
        var rtl = document.documentElement.dir === 'rtl';
        var dir = (rb.getAttribute('data-rail-btn') === 'next' ? 1 : -1) * (rtl ? -1 : 1);
        rail.scrollBy({ left: dir * Math.max(300, rail.clientWidth * 0.8), behavior: 'smooth' });
      }
    }
  });
  document.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = document.getElementById('gallery-main');
      if (main) { main.src = b.getAttribute('data-thumb'); }
    });
  });
  var hdr = document.querySelector('.hdr');
  if (hdr && document.body.classList.contains('tpl-index')) {
    var onScroll = function () { hdr.classList.toggle('is-solid', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
  var hero = document.querySelector('[data-hero]');
  if (hero) {
    var slides = hero.querySelectorAll('.hero__slide');
    var ticks = hero.querySelectorAll('.ticks button');
    var plates = hero.querySelectorAll('[data-plate]');
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      ticks.forEach(function (t, k) { t.classList.remove('is-on'); if (k === i) { void t.offsetWidth; t.classList.add('is-on'); } });
      plates.forEach(function (p, k) { p.hidden = k !== i; });
    }
    function loop() { clearTimeout(timer); timer = setTimeout(function () { go(i + 1); loop(); }, 6500); }
    ticks.forEach(function (t, k) { t.addEventListener('click', function () { go(k); loop(); }); });
    if (slides.length) { go(0); if (slides.length > 1) loop(); }
    var v = hero.querySelector('.hero__video');
    if (v) { v.addEventListener('canplay', function () { v.classList.add('is-ready'); v.play && v.play().catch(function () {}); }); }
  }
})();
